export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  JSON: { input: unknown; output: unknown; }
};

export type Company = {
  __typename?: 'Company';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyFilterOption = {
  __typename?: 'CompanyFilterOption';
  company: Company;
  count: Scalars['Int']['output'];
};

export type CreateFilterViewInput = {
  filters: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  viewKey: Scalars['String']['input'];
  visibility: FilterVisibility;
};

export type CreateLeadInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDateRange = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type CustomTimeRange = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  annualSalesPotential?: Maybe<Scalars['Decimal']['output']>;
  associationMemberships?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  businessStatus?: Maybe<CustomerBusinessStatus>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditLimitAllowed?: Maybe<Scalars['Decimal']['output']>;
  creditLimitUsed?: Maybe<Scalars['Decimal']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerGroupId?: Maybe<Scalars['ID']['output']>;
  dunningLevel?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  employeeCount?: Maybe<Scalars['Int']['output']>;
  erpId: Scalars['ID']['output'];
  facebookUrl?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industrySector?: Maybe<Scalars['String']['output']>;
  insights: InsightConnection;
  isVisited?: Maybe<Scalars['Boolean']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes: NoteConnection;
  notesPerSalesMetric?: Maybe<Scalars['Float']['output']>;
  orderBlock?: Maybe<Scalars['String']['output']>;
  ownExhibition?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  priceGroup?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<CustomerAddress>;
  salesDocuments: SalesDocumentConnection;
  salesMetric: SalesMetric;
  salesRegion?: Maybe<Scalars['String']['output']>;
  salesReps: Array<SalesRep>;
  status: CustomerStatus;
  taxNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitCadenceInWeeks?: Maybe<Scalars['Int']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type CustomerInsightsArgs = {
  filter: InsightFilter;
};


export type CustomerNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


export type CustomerNotesPerSalesMetricArgs = {
  notes: NoteFilter;
  salesMetric: SalesMetricFilter;
};


export type CustomerSalesDocumentsArgs = {
  filter?: InputMaybe<SalesDocumentsFilter>;
};


export type CustomerSalesMetricArgs = {
  filter: SalesMetricFilter;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  postBox?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerAddressType>;
  zipCode?: Maybe<Scalars['String']['output']>;
  zipCodePostBox?: Maybe<Scalars['String']['output']>;
};

export const CustomerAddressType = {
  BILLING: 'BILLING',
  PRIMARY: 'PRIMARY',
  SHIPPING: 'SHIPPING'
} as const;

export type CustomerAddressType = typeof CustomerAddressType[keyof typeof CustomerAddressType];
export const CustomerBusinessStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const;

export type CustomerBusinessStatus = typeof CustomerBusinessStatus[keyof typeof CustomerBusinessStatus];
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  edges: Array<CustomerEdge>;
  filterOptions: CustomerFilterOptions;
  nodes: Array<Customer>;
  pageInfo: PageInfo;
  salesMetric: SalesMetric;
  totalCount: Scalars['Int']['output'];
};


export type CustomerConnectionSalesMetricArgs = {
  filter: SalesMetricFilter;
};

export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  cursor: Scalars['String']['output'];
  node: Customer;
};

export const CustomerFieldSortKey = {
  CUSTOMER_NAME: 'customer_name',
  STATUS: 'status'
} as const;

export type CustomerFieldSortKey = typeof CustomerFieldSortKey[keyof typeof CustomerFieldSortKey];
export type CustomerFilter = {
  cityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerClasses?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  industryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  insightTypes?: InputMaybe<Array<InsightType>>;
  salesRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRepIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CustomerStatus>>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerFilterOptions = {
  __typename?: 'CustomerFilterOptions';
  cityNames: Array<StringFilterOption>;
  companyIds: Array<CompanyFilterOption>;
  customerClasses: Array<StringFilterOption>;
  industryNames: Array<StringFilterOption>;
  insightTypes: Array<InsightTypeFilterOption>;
  salesRegions: Array<StringFilterOption>;
  salesRepIds: Array<SalesRepFilterOption>;
  statuses: Array<CustomerStatusFilterOption>;
  zipCodes: Array<StringFilterOption>;
};

export type CustomerSort = {
  by: CustomerSortBy;
  direction: SortDirection;
};

export type CustomerSortBy =
  { field: CustomerFieldSortKey; insights?: never; notes?: never; notesPerSalesMetric?: never; salesDocuments?: never; salesMetric?: never; }
  |  { field?: never; insights: InsightAggregatesSort; notes?: never; notesPerSalesMetric?: never; salesDocuments?: never; salesMetric?: never; }
  |  { field?: never; insights?: never; notes: NoteSort; notesPerSalesMetric?: never; salesDocuments?: never; salesMetric?: never; }
  |  { field?: never; insights?: never; notes?: never; notesPerSalesMetric: NotesPerSalesMetricSort; salesDocuments?: never; salesMetric?: never; }
  |  { field?: never; insights?: never; notes?: never; notesPerSalesMetric?: never; salesDocuments: SalesDocumentsSort; salesMetric?: never; }
  |  { field?: never; insights?: never; notes?: never; notesPerSalesMetric?: never; salesDocuments?: never; salesMetric: SalesMetricSort; };

export const CustomerStatus = {
  ACTIVE: 'active',
  AT_RISK: 'at_risk',
  /** Blocked in the ERP. Takes precedence over every other status and cannot be changed in Plato. */
  BLOCKED: 'blocked',
  DORMANT: 'dormant',
  INACTIVE: 'inactive',
  NEW: 'new'
} as const;

export type CustomerStatus = typeof CustomerStatus[keyof typeof CustomerStatus];
export type CustomerStatusFilterOption = {
  __typename?: 'CustomerStatusFilterOption';
  count: Scalars['Int']['output'];
  value: CustomerStatus;
};

export type DateRange =
  { custom: CustomDateRange; preset?: never; }
  |  { custom?: never; preset: RangePreset; };

export type FilterView = {
  __typename?: 'FilterView';
  createdAt: Scalars['DateTime']['output'];
  createdBy: PlatoUser;
  filters: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderIndex?: Maybe<Scalars['Int']['output']>;
  viewKey: Scalars['String']['output'];
  visibility: FilterVisibility;
};

export const FilterVisibility = {
  ONLY_ME: 'only_me',
  TEAM: 'team'
} as const;

export type FilterVisibility = typeof FilterVisibility[keyof typeof FilterVisibility];
export type Insight = {
  __typename?: 'Insight';
  absoluteNumber?: Maybe<Scalars['Float']['output']>;
  actionableEntityId?: Maybe<Scalars['ID']['output']>;
  actionableEntityType?: Maybe<Scalars['String']['output']>;
  aggregatedAt?: Maybe<Scalars['DateTime']['output']>;
  aggregatedId?: Maybe<Scalars['ID']['output']>;
  batchId?: Maybe<Scalars['ID']['output']>;
  expandedViewArgumentsJson?: Maybe<Scalars['JSON']['output']>;
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insightType?: Maybe<InsightType>;
  percentageNumber?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonLocale?: Maybe<Scalars['String']['output']>;
  templateArgumentsJson?: Maybe<Scalars['JSON']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export const InsightAggregatesField = {
  TOTAL_COUNT: 'total_count',
  TOTAL_SUM: 'total_sum'
} as const;

export type InsightAggregatesField = typeof InsightAggregatesField[keyof typeof InsightAggregatesField];
export type InsightAggregatesSort = {
  dimension: InsightFilter;
  field: InsightAggregatesField;
};

export type InsightConnection = {
  __typename?: 'InsightConnection';
  totalAmount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type InsightFilter = {
  types?: InputMaybe<Array<InsightType>>;
};

export const InsightType = {
  CHURN_WARNING_WEB_CATEGORY: 'ChurnWarningWebCategory',
  FIRST_PURCHASE_WEB_CAT3: 'FirstPurchaseWebCat3',
  GLOBAL_CHURN_WARNING: 'GlobalChurnWarning',
  GLOBAL_TOP_CATEGORY: 'GlobalTopCategory',
  INDUSTRY_TOP_CATEGORY: 'IndustryTopCategory',
  PREVIOUSLY_PURCHASED_CATEGORY: 'PreviouslyPurchasedCategory',
  SHARE_OF_WALLET_CATEGORY: 'ShareOfWalletCategory',
  X_SELL_WEB_CATEGORY: 'XSellWebCategory'
} as const;

export type InsightType = typeof InsightType[keyof typeof InsightType];
export type InsightTypeFilterOption = {
  __typename?: 'InsightTypeFilterOption';
  count: Scalars['Int']['output'];
  value: InsightType;
};

export type Mutation = {
  __typename?: 'Mutation';
  createFilterView: FilterView;
  createLead: Scalars['ID']['output'];
  deleteFilterView: Scalars['Boolean']['output'];
  updateFilterView: FilterView;
};


export type MutationCreateFilterViewArgs = {
  input: CreateFilterViewInput;
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationDeleteFilterViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateFilterViewArgs = {
  input: UpdateFilterViewInput;
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  lastOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type NoteFilter = {
  interactionHappened?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<TimeRange>;
  types?: InputMaybe<Array<NoteType>>;
};

export type NoteSort = {
  dimension?: InputMaybe<NoteFilter>;
  field: NoteSortField;
};

export const NoteSortField = {
  LAST_OCCURRED_AT: 'last_occurred_at',
  TOTAL_COUNT: 'total_count'
} as const;

export type NoteSortField = typeof NoteSortField[keyof typeof NoteSortField];
export const NoteType = {
  NOTE: 'NOTE',
  PHONE_CALL: 'PHONE_CALL',
  VISIT: 'VISIT'
} as const;

export type NoteType = typeof NoteType[keyof typeof NoteType];
export type NotesPerSalesMetricSort = {
  notes: NoteFilter;
  salesMetric: SalesMetricFilter;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PlatoUser = {
  __typename?: 'PlatoUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  companies: Array<Maybe<Company>>;
  customers: CustomerConnection;
  filterViews: Array<FilterView>;
  salesReps: Array<Maybe<SalesRep>>;
};


export type QueryCompaniesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy: CustomerSort;
};


export type QueryFilterViewsArgs = {
  viewKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySalesRepsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export const RangePreset = {
  FULL_YEAR: 'FULL_YEAR',
  LAST_MONTH: 'LAST_MONTH',
  LAST_QUARTER: 'LAST_QUARTER',
  LAST_WEEK: 'LAST_WEEK',
  TODAY: 'TODAY',
  TTM: 'TTM',
  YESTERDAY: 'YESTERDAY',
  YTD: 'YTD'
} as const;

export type RangePreset = typeof RangePreset[keyof typeof RangePreset];
export type SalesDocumentConnection = {
  __typename?: 'SalesDocumentConnection';
  firstDate?: Maybe<Scalars['Date']['output']>;
  lastDate?: Maybe<Scalars['Date']['output']>;
  totalCount: Scalars['Int']['output'];
};

export const SalesDocumentStatus = {
  BILLED: 'BILLED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  LOST: 'LOST',
  OPEN: 'OPEN',
  OPEN_IN_PICKING: 'OPEN_IN_PICKING',
  OTHER: 'OTHER',
  PARTIALLY_BILLED: 'PARTIALLY_BILLED',
  PARTIALLY_PICKED: 'PARTIALLY_PICKED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  PARTIALLY_SHIPPED: 'PARTIALLY_SHIPPED',
  PENDING: 'PENDING',
  PICKED: 'PICKED',
  PROCESSED_INTERNALLY: 'PROCESSED_INTERNALLY',
  RECEIVED: 'RECEIVED',
  RELEASED_FOR_DELIVERY: 'RELEASED_FOR_DELIVERY',
  RETURNED: 'RETURNED',
  REVISED: 'REVISED',
  SHIPPED: 'SHIPPED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type SalesDocumentStatus = typeof SalesDocumentStatus[keyof typeof SalesDocumentStatus];
export const SalesDocumentType = {
  CONTRACT: 'CONTRACT',
  CREDITNOTE: 'CREDITNOTE',
  CREDIT_MEMO_REQUEST: 'CREDIT_MEMO_REQUEST',
  DEBIT_MEMO_REQUEST: 'DEBIT_MEMO_REQUEST',
  ORDER: 'ORDER',
  QUOTE: 'QUOTE',
  RETURN: 'RETURN'
} as const;

export type SalesDocumentType = typeof SalesDocumentType[keyof typeof SalesDocumentType];
export type SalesDocumentsFilter = {
  statuses?: InputMaybe<Array<SalesDocumentStatus>>;
  types?: InputMaybe<Array<SalesDocumentType>>;
};

export type SalesDocumentsSort = {
  dimension?: InputMaybe<SalesDocumentsFilter>;
  field: SalesDocumentsSortField;
};

export const SalesDocumentsSortField = {
  FIRST_DATE: 'first_date',
  LAST_DATE: 'last_date',
  TOTAL_COUNT: 'total_count'
} as const;

export type SalesDocumentsSortField = typeof SalesDocumentsSortField[keyof typeof SalesDocumentsSortField];
export type SalesMetric = {
  __typename?: 'SalesMetric';
  deltaGrossMargin: Scalars['Float']['output'];
  deltaPercentGrossMargin?: Maybe<Scalars['Float']['output']>;
  deltaPercentTotalAmount?: Maybe<Scalars['Float']['output']>;
  deltaPercentUnits?: Maybe<Scalars['Float']['output']>;
  deltaTotalAmount: Scalars['Float']['output'];
  deltaUnits: Scalars['Float']['output'];
  grossMargin: Scalars['Float']['output'];
  previousGrossMargin: Scalars['Float']['output'];
  previousTotalAmount: Scalars['Float']['output'];
  previousUnits: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
};

export const SalesMetricBasis = {
  BILLED: 'BILLED',
  BILLED_WO_CREDIT_NOTE: 'BILLED_WO_CREDIT_NOTE',
  NOT_BILLED: 'NOT_BILLED',
  ORDER_SUM: 'ORDER_SUM'
} as const;

export type SalesMetricBasis = typeof SalesMetricBasis[keyof typeof SalesMetricBasis];
export type SalesMetricFilter = {
  basis: SalesMetricBasis;
  range: DateRange;
};

export type SalesMetricSort = {
  dimension: SalesMetricFilter;
  field: SalesMetricSortField;
};

export const SalesMetricSortField = {
  DELTA_GROSS_MARGIN: 'delta_gross_margin',
  DELTA_PERCENT_GROSS_MARGIN: 'delta_percent_gross_margin',
  DELTA_PERCENT_TOTAL_AMOUNT: 'delta_percent_total_amount',
  DELTA_PERCENT_UNITS: 'delta_percent_units',
  DELTA_TOTAL_AMOUNT: 'delta_total_amount',
  DELTA_UNITS: 'delta_units',
  GROSS_MARGIN: 'gross_margin',
  PREVIOUS_GROSS_MARGIN: 'previous_gross_margin',
  PREVIOUS_TOTAL_AMOUNT: 'previous_total_amount',
  PREVIOUS_UNITS: 'previous_units',
  TOTAL_AMOUNT: 'total_amount',
  UNITS: 'units'
} as const;

export type SalesMetricSortField = typeof SalesMetricSortField[keyof typeof SalesMetricSortField];
export type SalesRep = {
  __typename?: 'SalesRep';
  id: Scalars['ID']['output'];
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SalesRepFilterOption = {
  __typename?: 'SalesRepFilterOption';
  count: Scalars['Int']['output'];
  salesRep: SalesRep;
};

export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export type StringFilterOption = {
  __typename?: 'StringFilterOption';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type TimeRange =
  { custom: CustomTimeRange; preset?: never; }
  |  { custom?: never; preset: RangePreset; };

export type UpdateFilterViewInput = {
  filters: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  visibility: FilterVisibility;
};
